<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش عملکرد ترانزیت </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <div [formGroup]="mdl_Search" class="container-fluid row gx-0 gy-0 mt-0">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> از تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strSDate" placeholder="از تاریخ"
                        class="form-control text-end" />

                </ng-persian-datepicker>

            </div>


        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> تا تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strEDate" placeholder="از تاریخ"
                        class="form-control text-end" />

                </ng-persian-datepicker>

            </div>

        </div>

        <!-- متحرک -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> متحرک </label>

                <select class="form-select p-2" formControlName="strUnitID">

                    <option class="text-center" value=""> انتخاب کنید </option>

                    <option class="" *ngFor="let item of lstCars" [value]="item.strUnitID">

                        {{ item.strFullName | faNum}}

                    </option>

                </select>

            </div>


        </div>

        <!-- وضعیت -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> وضعیت </label>

                <select class="form-select p-2" formControlName="tiTripStatus">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" value="0"> منتظر بارگیری </option>

                    <option class="text-center" value="1"> در حال بارگیری </option>

                    <option class="text-center" value="2"> تکمیل بارگیری </option>

                    <option class="text-center" value="3"> خروج از مبداء </option>

                    <option class="text-center" value="4"> ورود به مقصد </option>

                    <option class="text-center" value="5"> تخلیه بار </option>

                    <option class="text-center" value="6"> خروج از مقصد </option>

                </select>

            </div>


        </div>

        <!-- کاربری -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> کاربری </label>

                <select class="form-select p-2" formControlName="tiMobileType">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option *ngFor="let item of lstMobileType" [value]="item.tiMobileType">

                        {{ item.strComment | faNum}}

                    </option>

                </select>

            </div>


        </div>

        <!-- مبداء/مقصد -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> مبداء/مقصد </label>

                <select class="form-select p-2" formControlName="iSDGeoFence">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                        {{ item.strTitle }}

                    </option>

                </select>

            </div>

        </div>

        <!-- اهمیت -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> اهمیت </label>

                <select class="form-select p-2" formControlName="tiLoadImportance">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" value="0"> عادی </option>

                    <option class="text-center" value="1"> مهم </option>

                    <option class="text-center" value="2"> خیلی مهم </option>

                </select>

            </div>

        </div>

        <!-- نتیجه -->

        <div class="col-12 col-md-2">

            <div class="position-relative w-100 h-100 p-2">

                <label class="mb-2 text-muted"> نتیجه </label>

                <select class="form-select p-2" formControlName="tiResultTrip">

                    <option class="text-center" value="-1"> انتخاب کنید </option>

                    <option class="text-center" value="0"> مطابق برنامه ریزی </option>

                    <option class="text-center" value="1"> زودتر از برنامه ریزی </option>

                    <option class="text-center" value="2"> دیرتراز برنامه ریزی </option>

                </select>

            </div>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative p-md-2">

            <button class="w-100 btn btn-primary" (click)="search_Report()">

                &nbsp; جستجو &nbsp;

            </button>

        </div>
        
        <!-- تحلیل عملکرد -->

        <div class="col-12 col-md-auto position-relative p-md-2">

            <button class="w-100 btn btn-warning" (click)="analyze()">

                &nbsp; تحلیل عملکرد &nbsp;

            </button>

        </div>

    </div>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-2 gy-md-0 gy-3">

            <!-- اینپوت جستجو -->

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 330px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> نام راننده </th>

                        <th class="text-center"> مسیر </th>

                        <th class="text-center"> کاربری </th>

                        <th class="text-center"> مدت سفر </th>

                        <th class="text-center"> توقف در مبداء </th>

                        <th class="text-center"> توقف در مقصد </th>

                        <th class="text-center"> توقف در مسیر </th>

                        <th class="text-center"> مطابق برنامه </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Reports;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <i class="fa fa-stop-circle fa-lg pointer" title="توقف ها" (click)="openRoute_Stops(item)"></i>

                            <i class="fa fa-road mx-2 fa-lg pointer" title="مسیر" (click)="open_Location(item)"></i>
                            
                        </th>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strRoute | faNum }} </td>

                        <td> {{ item.strMobileType_strComment | faNum }} </td>

                        <td> {{ item.strResultTime | faNum }} </td>

                        <td> {{ item.strSDuration | faNum }} </td>

                        <td> {{ item.strDDuration | faNum }} </td>

                        <td> {{ item.iStops | faNum }} </td>

                        <td> {{ item.strResultTrip | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

        <div class="row gx-0 gy-0 p-2 bg-secondary">

            <span class="col-md-auto col-12 text-white"> مدت سفر : {{ iTripTime | number:'1.0-0' | faNum }} دقیقه
            </span>

            <span class="col-md-auto col-12 text-white mx-md-5"> تعداد توقف : {{ iStops | number:'1.0-0' | faNum }} عدد
            </span>

            <span class="col-md-auto col-12 text-white"> توقف در مسیر : {{ iStopsTime | number:'1.0-0' | faNum }} دقیقه
            </span>

        </div>

    </div>

</main>